// Module-singleton snapshot for the Feedback Report: component state is lost on
// unmount, so re-entry renders this instantly then revalidates in the background.
// One snapshot per SPA session (GET /feedback is param-free); resets on reload.

let snapshot = null; // { feedback, isAdmin, canReply, savedAt }

export const getFeedbackSnapshot = () => snapshot;

export const saveFeedbackSnapshot = (data) => {
  snapshot = { ...data, savedAt: Date.now() };
};

export const clearFeedbackSnapshot = () => {
  snapshot = null;
};
